module.exports = __webpack_public_path__ + "img/machine_1.e6e4ae4d.jpg";